// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-placeholder {
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: var(--slate);
  color: var(--mut);
  text-align: center;
  padding: 40px 24px;
}

.map-placeholder-icon {
  font-size: 56px !important;
  color: var(--cyan);
}

.map-placeholder h2 {
  color: #fff;
  font-size: 26px;
}

.map-placeholder p {
  font-size: 15px;
  max-width: 380px;
  color: var(--mut);
}
`, "",{"version":3,"sources":["webpack://./src/components/organisms/MapPlaceholder/MapPlaceholder.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".map-placeholder {\n  min-height: calc(100vh - 64px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  background: var(--slate);\n  color: var(--mut);\n  text-align: center;\n  padding: 40px 24px;\n}\n\n.map-placeholder-icon {\n  font-size: 56px !important;\n  color: var(--cyan);\n}\n\n.map-placeholder h2 {\n  color: #fff;\n  font-size: 26px;\n}\n\n.map-placeholder p {\n  font-size: 15px;\n  max-width: 380px;\n  color: var(--mut);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
